module.exports = __webpack_public_path__ + "img/logo-livecities.cd2d36ee.png";